import React, { useEffect, useRef, useState } from "react";
import ListInfo from "../../BookModule.module.css";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ViewIcon from "../BookTabs/ViewIcon.png";
import StarIcon from "./RatingIcon.png";
import GreyStarIcon from "./RatingWhiteIcon.png";
import { AxiosInstance } from "../../../../../../axios";
import { R_PER_PAGE } from "../../../../../../labels";
import Pagination from "../../../../../ReusuableComponent/Pagination/Pagination";
import Loader from "../../../../Loader";
import moment from "moment";
import DatePickerSample from "../../../../DatePicker";
import CustomDownloadButton from "../../../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import toast from "react-hot-toast";

export default function ListReview() {
  const navigate = useNavigate();
  const location = useLocation();
  let page = R_PER_PAGE;
  const filterRef = useRef(null);
  const filterRefss = useRef(null);
  const filterLastRef = useRef(null);
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);
  const { filRating, filApproval, filter_date } = location.state || [];
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [updateChipData, setUpdateChipData] = useState([]);
  const [csvData, setCsvData] = useState([]);

  const [updateListData, setUpdateListData] = useState();
  const [sortOrder, setSortOrder] = useState("asc");
  const [ratingOn, setRatingOn] = useState([]);
  const [statusOn, setStatusOn] = useState([]);
  const [isOpen, setIsOpen] = useState({
    rating: false,
    status: false,
    startDates: false,
  });
  const [appOns, setAppOns] = useState([]);
  const [appDatas, setAppDatas] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });

  function updateStateData() {
    filterRating = ratingOn;
    filterStatus = statusOn;
    filterApplyeds = appOns;
  }
  useEffect(() => {
    setUpdateListData(updateListData);
  }, [updateListData]);
  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
  };
  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "rating") {
      if (checked) {
        // Add the selected rating to the array
        setRatingOn((prev) => [
          ...prev,
          { id: parseInt(value), name: name, type: "rating" },
        ]);
      } else {
        // Remove the unchecked rating from the array
        setRatingOn((prev) =>
          prev.filter((item) => item.id !== parseInt(value))
        );
      }
    } else if (
      typename === "Waitingforapproval" ||
      typename === "Approved" ||
      typename === "Rejected"
    ) {
      if (checked) {
        // Add the selected status to the array
        setStatusOn((prev) => [
          ...prev,
          { id: parseInt(value), name: name, type: "status" },
        ]);
      } else {
        // Remove the unchecked status from the array
        setStatusOn((prev) =>
          prev.filter((item) => item.id !== parseInt(value))
        );
      }
    }
  };
  const handleClear = (name) => {
    const updatedChips = updateChipData.filter((item) => item.type !== name);
    setUpdateChipData(updatedChips);
    setIsOpen({
      rating: false,
      status: false,
      startDates: false,
    });
    if (name === "rating") {
      updateStateData();
      setRatingOn([]);
      filterRating = [];
    } else if (name === "status") {
      updateStateData();
      setStatusOn([]);
      filterStatus = [];
    } else if (name === "appliedOns") {
      updateStateData();
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
      setIsOpen({
        ...isOpen,
        startDates: false,
      });
    }
    setTimeout(() => {
      loadChipdata();
    }, 500);
  };
  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "rating") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        rating: false,
      });
    } else if (name === "status") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "appliedOns") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        startDates: false,
      });
    }
  };
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));
  const handleAllClear = () => {
    setRatingOn([]);
    setStatusOn([]);
    setUpdateChipData([]);
    setAppOns([]);
    setAppDatas({
      FDate: "",
      TDate: "",
      Days: "",
    });
    // loadListdata();
  };

  const handleFilter = (e, boxName) => {
    if (boxName === "rating") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        rating: !prevState.rating, // Toggle the value
        status: false,
        startDates: false,
      }));
      setRatingOn(updateChipData.filter((ui) => ui.type === "rating"));
    } else if (boxName === "status") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        status: !prevState.status, // Toggle the value
        rating: false,
        startDates: false,
      }));
      setStatusOn(updateChipData.filter((ui) => ui.type === "status"));
    } else if (boxName === "startDates") {
      setIsOpen((prevState) => ({
        rating: false,
        status: false,
        startDates: !prevState.startDates,
      }));
    }
  };

  function loadListdata() {
    let tempRating = [];
    let tempStaus = [];
    ratingOn.map((obj) => {
      tempRating.push(Number(obj.id));
    });
    statusOn.map((obj) => {
      tempStaus.push(Number(obj.id));
    });

    let statusFilter = {
      page: "",
      page_size: "",
      status: statusOn.length > 0 ? tempStaus : "",
      rating: ratingOn.length > 0 ? tempRating : "",
      start_date: appOns.length > 0 ? appOns[0].fdate || appOns[0].FDate : "",
      end_date: appOns.length > 0 ? appOns[0].edate || appOns[0].TDate : "",
    };
    setIsLoading(true);
    AxiosInstance.post("/api/book/review/list", statusFilter)
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          setCurrentPage(1);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));

          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            book_title: item.book_title,
            username: item.username,
            email: item.email,
            phone_no: item.phone_no,
            date: `${moment(item.date).format("DD/MM/YYYY")}`,
            rating: item.rating,
            review: item.review,
            status:
              item.status === 0
                ? "Waiting For Approval"
                : item.status === 1
                  ? "Approved"
                  : "Rejected",
          }));
          // Set CSV data
          setCsvData(csvFormattedData);

          setUpdateListData(serialNumberAddedData);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }
  let filterRating = [];
  let filterStatus = [];
  let filterApplyeds = [];
  useEffect(() => {
    filterRating = ratingOn;
  }, [ratingOn]);
  useEffect(() => {
    filterApplyeds = appOns;
  }, [appDatas]);
  useEffect(() => {
    filterStatus = statusOn;
  }, [statusOn]);

  function loadChipdata() {
    let tempArr = [];
    filterRating.map((obj) => {
      tempArr.push(obj);
    });
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyeds.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "rating") {
      setRatingOn(ratingOn.filter((item) => item.id !== chipToDelete.id));
      filterRating = ratingOn.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "status") {
      setStatusOn(statusOn.filter((item) => item.id !== chipToDelete.id));
      filterStatus = statusOn.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "dayRanges") {
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
    } else {
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
    }
    loadChipdata();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");

      if (isCheckbox || isApplyFilterButton || isChipData) return;

      // CATEGORY FILTER
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        const hasRating = updateChipData.some(
          (chipItem) => chipItem.type === "rating"
        );

        if (hasRating) {
          const updatedCategory = updateChipData.filter(
            (chipItem) => chipItem.type === "rating"
          );
          setRatingOn(updatedCategory);
        } else {
          setRatingOn([]);
        }
        setIsOpen((prev) => ({ ...prev, rating: false }));
      }

      // TYPE FILTER
      if (filterRefss.current && !filterRefss.current.contains(event.target)) {
        const hasType = updateChipData.some(
          (chipItem) => chipItem.type === "status"
        );

        if (hasType) {
          const updatedType = updateChipData.filter(
            (chipItem) => chipItem.type === "status"
          );
          setStatusOn(updatedType);
        } else {
          setStatusOn([]);
        }

        setIsOpen((prev) => ({ ...prev, status: false }));
      }
      // if (
      //   filterLastRef.current &&
      //   !filterLastRef.current.contains(event.target)
      // ) {
      //   const mismatchedDay = updateChipData.find(
      //     (chipItem) => chipItem.Days && chipItem.Days === appDatas.Days
      //   );
      //   if (mismatchedDay) {
      //     setAppDatas({
      //       FDate: "",
      //       TDate: "",
      //       Days: mismatchedDay.Days,
      //     });
      //     setAppOns([
      //       {
      //         name: mismatchedDay.name || "",
      //         FDate: "",
      //         TDate: "",
      //         Days: mismatchedDay.Days,
      //       },
      //     ]);
      //   } else {
      //     const mismatchedDate = updateChipData.find(
      //       (chipItem) =>
      //         chipItem.fdate === appDatas.FDate &&
      //         chipItem.edate === appDatas.TDate
      //     );
      //     if (mismatchedDate) {
      //       setAppDatas((prev) => ({
      //         ...prev,
      //         FDate: mismatchedDate.fdate,
      //         TDate: mismatchedDate.edate,
      //         Days: "",
      //       }));
      //       setAppOns([
      //         {
      //           name:
      //             mismatchedDate.name ||
      //             `${mismatchedDate.fdate} - ${mismatchedDate.edate}`,
      //           FDate: mismatchedDate.fdate,
      //           TDate: mismatchedDate.edate,
      //           Days: "",
      //         },
      //       ]);
      //     } else {
      //       setAppDatas({
      //         FDate: "",
      //         TDate: "",
      //         Days: "",
      //       });
      //       setAppOns([]);
      //     }
      //   }
      //   setIsOpen((prev) => ({ ...prev, startDates: false }));
      // }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData]);

  useEffect(() => {
    if (filRating && filRating.length > 0) {
      setRatingOn(filRating);
      filterRating = filRating;
    } else {
      setRatingOn(ratingOn);
      filterRating = ratingOn;
    }
    if (filApproval && filApproval.length > 0) {
      setStatusOn(filApproval);
      filterStatus = filApproval;
    } else {
      setStatusOn(statusOn);
      filterStatus = statusOn;
    }
    if (filter_date && filter_date.length > 0) {
      const filterDates = filter_date[0];
      setAppDatas({
        FDate: filterDates.fdate,
        TDate: filterDates.edate,
        Days: filterDates.Days,
        name: "",
      });
      setAppOns(filter_date);
      filterApplyeds = filter_date;
    }
    setIsFiltersInitialized(true);
    loadChipdata();
  }, [filRating, filApproval, filter_date]);
  useEffect(() => {
    if (isFiltersInitialized && filRating && filRating.length > 0) {
      loadListdata();
    } else if (isFiltersInitialized && filApproval && filApproval.length > 0) {
      loadListdata();
    } else if (isFiltersInitialized && filter_date && filter_date.length > 0) {
      loadListdata();
    }
  }, [
    filRating,
    filApproval,
    filter_date,
    isFiltersInitialized,
    updateChipData,
  ]);
  useEffect(() => {
    if (isFiltersInitialized) {
      loadListdata();
    }
  }, [isFiltersInitialized, updateChipData]);
  // List data load table

  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }
  }, []);
  // useEffect(() => {
  //   if (location.state) {
  //   }
  // }, [location.state]);

  // useEffect(() => {
  //   if (location.state) {
  //     const timer = setTimeout(() => {
  //       navigate(location.pathname, { replace: true, state: null });
  //     }, 100);
  //     return () => clearTimeout(timer);
  //   }
  // }, [location.pathname]);

  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);

  const currentData = updateListData?.slice(start, end);

  const generatePDF = () => {
    const headers = [
      "Book Name",
      "User Name",
      "Phone Number",
      "Date",
      "Ratings",
      "Review",
    ];

    const rows = csvData.map((item, index) => [
      item.book_title ?? "",
      item.username ?? "",
      item.phone_no ?? "",
      item.date ?? "",
      item.rating ?? "",
      item.review ?? "",
    ]);

    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Review Data",
          headers,
          rows,
          filename: "Review.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  const handleNavigate = (idid) => {
    const formattedAppOns = appOns.map((item) => ({
      name:
        item.name ||
        (item.FDate && item.TDate ? `${item.FDate} - ${item.TDate}` : ""),
      fdate: item.fdate || item.FDate,
      edate: item.edate || item.TDate,
      type: item.type || "dateRange",
    }));
    navigate(`/studyMaterials/Books/Reviews/View/${idid}`, {
      state: {
        RATING: ratingOn,
        APPROVALSTATUS: statusOn,
        DATE: formattedAppOns,
      },
    });
  };
  const handleAppliedOns = (e) => {
    const { name, value, checked } = e.target;
    if (name === "FDate" || name === "TDate") {
      setAppDatas((prevState) => {
        const updated = {
          ...prevState,
          [name]: value,
          Days: "", // Reset Days when FDate or TDate is changed
        };
        const from = name === "FDate" ? value : updated.FDate;
        const to = name === "TDate" ? value : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOns([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRanges",
              Days: "",
            },
          ]);
        } else {
          setAppOns([
            {
              name: "",
              fdate: "",
              edate: "",
              type: "dateRanges",
              Days: "",
            },
          ]);
        }
        return updated;
      });
    } else if (name === "Days") {
      if (checked) {
        // Set Days and reset FDate/TDate
        setAppDatas({
          FDate: "",
          TDate: "",
          Days: value,
        });
        const today = new Date();
        let fdate = "";
        let edate = "";
        let label = "";
        if (value === "Today") {
          fdate = edate = moment(today).format("YYYY-MM-DD");
          label = "Today";
        } else if (value === "Yesterday") {
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          fdate = edate = moment(yesterday).format("YYYY-MM-DD");
          label = "Yesterday";
        } else if (value === "Tweek") {
          const start = moment(today).startOf("week").toDate();
          const end = moment(today).endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This week";
        } else if (value === "Lweek") {
          const start = moment(today)
            .subtract(1, "week")
            .startOf("week")
            .toDate();
          const end = moment(today).subtract(1, "week").endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last week";
        } else if (value === "Tmonth") {
          const start = new Date(today.getFullYear(), today.getMonth(), 1);
          const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This month";
        } else if (value === "Lmonth") {
          const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const end = new Date(today.getFullYear(), today.getMonth(), 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last month";
        }
        setAppOns([
          {
            name: label,
            fdate,
            edate,
            type: "dayRanges",
            Days: value,
          },
        ]);
      }
    }
  };
  const handleChangeDate_app = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");
    if (name === "FDate" || name === "TDate") {
      setAppDatas((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };
        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOns([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  const csvHeaders = [
    { label: "Serial Number", key: "serialNumber" },
    { label: "Book Name", key: "book_title" },
    { label: "User BName", key: "username" },
    { label: "Email ID", key: "email" },
    { label: "Phone Number", key: "phone_no" },
    { label: "Date", key: "date" },
    { label: "Rating", key: "rating" },
    { label: "Review", key: "review" },
    { label: "Approval Status", key: "status" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={`BathHeader global_container BathDet`}>
      <div className="row mx-0">
        <div className="col-md-6 col-12 px-0">
          <h2 className="TitleHeader">Reviews</h2>
        </div>
        <div className="col-md-6 col-12 px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <CustomDownloadButton
                csvListData={csvData?.length > 0 ? csvData : ""}
                headers={csvHeaders}
                iconName=" file_download "
                filename={"Reviews.csv"}
                csvName="  Download as CSV"
              />
            </li>
            <li class="ListBtnItems primaryButton" onClick={generatePDF}>
              <span className="material-icons me-1 align-middle text-white">
                file_download
              </span>
              Download as PDF
            </li>
          </ul>
        </div>
      </div>

      {updateChipData?.length > 0 ? (
        <div className="row mx-0">
          <div className="col-md-12 px-0 col-sm-12 col-xs-12 paperil_global">
            <Paper
              sx={{
                display: "flex",
                flexWrap: "wrap",
                listStyle: "none",
                boxShadow: "none",
                p: 0,
                m: 0,
              }}
              component="ul"
            >
              {updateChipData.map((data, index) => {
                let icon;
                return (
                  <ListItem key={index}>
                    <Chip
                      icon={icon}
                      label={
                        <>
                          <span className={ListInfo.BoldTyText}>
                            {data.name}
                          </span>
                        </>
                      }
                      onDelete={handleDelete(data, index)}
                    />
                  </ListItem>
                );
              })}
              <ListItem className="clearAll_list">
                <a
                  className="clearAll_listItem"
                  href="javascript:void(0)"
                  onClick={handleAllClear}
                >
                  Clear All Filters
                </a>
              </ListItem>
            </Paper>
          </div>
        </div>
      ) : (
        // No chips to show
        <div></div>
      )}
      <div className="row mx-0 mt-2">
        <div
          className={`col-md-12 ${ListInfo.table_responsive_padding} table-responsive tableMinHeight px-0 `}
        >
          <table className="table" id="tableListHeader">
            <thead>
              <tr>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "serialNumber")}
                    className="textHead_th"
                  >
                    S.No.
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "serialNumber")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "book_title")}
                    className="textHead_th"
                  >
                    Book Name
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "book_title")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "username")}
                    className="textHead_th"
                  >
                    User Name
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "username")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "email")}
                    className="textHead_th"
                  >
                    Email ID
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "email")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "phone_no")}
                    className="textHead_th"
                  >
                    Phone Number
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "phone_no")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={ListInfo.tableThPadding} ref={filterRef}>
                  <span
                    onClick={(e) => handleSort(e, "rating")}
                    className="textHead_th"
                  >
                    Ratings
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "rating")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                  <span
                    className={`textHead_th align-middle material-icons ${ratingOn.length > 0 || isOpen.rating
                        ? ListInfo.active_icons_book
                        : ""
                      } `} // Change here
                    onClick={(e) => handleFilter(e, "rating")}
                  >
                    filter_list
                  </span>
                  {isOpen.rating && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Rating - 1"}
                                value={1}
                                id={"Rating1"}
                                checked={ratingOn.some((element) => {
                                  if (element.id == 1) {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "rating", "rating")
                                }
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 1"
                              />
                              <img
                                className="ms-2"
                                src={GreyStarIcon}
                                alt="Rating 1"
                              />
                              <img
                                className="ms-2"
                                src={GreyStarIcon}
                                alt="Rating 1"
                              />
                              <img
                                className="ms-2"
                                src={GreyStarIcon}
                                alt="Rating 1"
                              />
                              <img
                                className="ms-2"
                                src={GreyStarIcon}
                                alt="Rating 1"
                              />
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Rating - 2"}
                                value={2}
                                id={"Rating2"}
                                checked={ratingOn.some((element) => {
                                  if (element.id == 2) {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "rating", "rating")
                                }
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 2"
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 2"
                              />
                              <img
                                className="ms-2"
                                src={GreyStarIcon}
                                alt="Rating 1"
                              />
                              <img
                                className="ms-2"
                                src={GreyStarIcon}
                                alt="Rating 1"
                              />
                              <img
                                className="ms-2"
                                src={GreyStarIcon}
                                alt="Rating 1"
                              />
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Rating - 3"}
                                value={3}
                                id={"Rating3"}
                                checked={ratingOn.some((element) => {
                                  if (element.id == 3) {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "rating", "rating")
                                }
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 3"
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 3"
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 3"
                              />
                              <img
                                className="ms-2"
                                src={GreyStarIcon}
                                alt="Rating 1"
                              />
                              <img
                                className="ms-2"
                                src={GreyStarIcon}
                                alt="Rating 1"
                              />
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Rating - 4"}
                                value={4}
                                id={"Rating4"}
                                checked={ratingOn.some((element) => {
                                  if (element.id == 4) {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "rating", "rating")
                                }
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 4"
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 4"
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 4"
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 4"
                              />
                              <img
                                className="ms-2"
                                src={GreyStarIcon}
                                alt="Rating 1"
                              />
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Rating - 5"}
                                value={5}
                                id={"Rating5"}
                                checked={ratingOn.some((element) => {
                                  if (element.id == 5) {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "rating", "rating")
                                }
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 5"
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 5"
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 5"
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 5"
                              />
                              <img
                                className="ms-2"
                                src={StarIcon}
                                alt="Rating 5"
                              />
                            </li>
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("rating")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={ratingOn.length === 0 ? true : false}
                                onClick={() => handleApplyFilter("rating")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    
                    </>
                  )}
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "review")}
                    className="textHead_th"
                  >
                    Review
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "review")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th
                  id="th"
                  className={ListInfo.tableThPadding}
                  ref={filterLastRef}
                >
                  <span
                    onClick={(e) => handleSort(e, "date")}
                    className="textHead_th"
                  >
                    Date
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "date")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                  <span
                    onClick={(e) => handleFilter(e, "startDates")}
                    class={` align-middle material-icons ${
                      (appDatas &&
                        Object.entries(appDatas).some(
                          ([key, val]) =>
                            key !== "name" &&
                            val !== null &&
                            val !== undefined &&
                            val.toString().trim() !== ""
                        )) ||
                      isOpen.startDates
                        ? ListInfo.active_icons_book
                        : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.startDates === true && (
                    <div className="filterBoxs_testlist container mt-2   p-1">
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="FDate"
                              className="d-flex form-label"
                            >
                              From Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                                                                                                   /> */}
                            <DatePickerSample
                              IconInput={"filterIocnBoxInput"}
                              class={"FilterInputs"}
                              name={"FDate"}
                              handleChange={handleChangeDate_app}
                              fieldInput={appDatas.FDate}
                              txtAdMDob={fDatePickerRef}
                              // maxDate={new Date()}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="TDate "
                              className="d-flex form-label"
                            >
                              To Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                                                                                                   /> */}
                            <DatePickerSample
                              class={"FilterInputs"}
                              IconInput={"filterIocnBoxInput"}
                              name={"TDate"}
                              handleChange={handleChangeDate_app}
                              fieldInput={appDatas.TDate}
                              txtAdMDob={tDatePickerRef}
                              minDate={appDatas.FDate}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className="row mt-2">
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              id="Today"
                              value="Today"
                              checked={appDatas.Days === "Today"}
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Today"
                              htmlFor="Today"
                              style={{ fontWeight: "bold" }}
                            >
                              Today
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Yesterday"
                              checked={appDatas.Days === "Yesterday"}
                              id="Yesterday"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Yesterday"
                              htmlFor="Yesterday"
                              style={{ fontWeight: "bold" }}
                            >
                              Yesterday
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tweek"
                              checked={appDatas.Days === "Tweek"}
                              id="Tweek"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tweek"
                              htmlFor="Tweek"
                              style={{ fontWeight: "bold" }}
                            >
                              This week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Lweek"
                              checked={appDatas.Days === "Lweek"}
                              id="Lweek"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lweek"
                              htmlFor="Lweek"
                              style={{ fontWeight: "bold" }}
                            >
                              Last week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tmonth"
                              checked={appDatas.Days === "Tmonth"}
                              id="Tmonth"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tmonth"
                              htmlFor="Tmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              This month
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              checked={appDatas.Days === "Lmonth"}
                              value="Lmonth"
                              id="Lmonth"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lmonth"
                              htmlFor="Lmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              Last month
                            </label>
                          </div>
                        </div>
                      </div> */}
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("appliedOns")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("appliedOns")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th
                  id="th"
                  className={ListInfo.tableThPadding}
                  ref={filterRefss}
                >
                  <div class={ListInfo.thcontent}>
                    <span
                      onClick={(e) => handleSort(e, "status")}
                      class="textHead_th"
                    >
                      Approval <br /> Status
                    </span>
                    <div class={ListInfo.iconcontainer} >
                      <span
                        onClick={(e) => handleSort(e, "status")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                      <span
                        className={`textHead_th align-middle material-icons ${statusOn.length > 0 || isOpen.status
                            ? ListInfo.active_icons_book
                            : ""
                          } `} // Change here
                        onClick={(e) => handleFilter(e, "status")}
                      >
                        filter_list
                      </span>
                      {/* 0 : waiting for approvel 1 : approved 2 : reject */}
                      {isOpen.status && (
                        <>
                          <div className="filterBoxs_testlist mt-3">
                            <div className="col-md-12 form-check filterStatus_list">
                              <ul className="ulFilterListData">
                                <li className="filterListData">
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={"Waiting For Approval"}
                                    value={0}
                                    id={"Waitingforapproval"}
                                    checked={statusOn.some((element) => {
                                      if (element.id == 0) {
                                        return true;
                                      }
                                      return false;
                                    })}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        "Waiting For Approval",
                                        "Waitingforapproval"
                                      )
                                    }
                                  />
                                  <label
                                    className={`form-check-label filterChipText  ms-3  ${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusYellow}`}
                                    htmlFor={"Waitingforapproval"}
                                  >
                                    Waiting For Approval
                                  </label>
                                </li>
                                <li className="filterListData">
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={"Approved"}
                                    value={1}
                                    checked={statusOn.some((element) => {
                                      if (element.id == 1) {
                                        return true;
                                      }
                                      return false;
                                    })}
                                    id={"Approved"}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        "Approved",
                                        "Approved"
                                      )
                                    }
                                  />
                                  <label
                                    className={`form-check-label filterChipText  ms-3  ${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusGreen}`}
                                    htmlFor={"Approved"}
                                  >
                                    Approved
                                  </label>
                                </li>
                                <li className="filterListData">
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={"Rejected"}
                                    value={2}
                                    id={"Rejected"}
                                    checked={statusOn.some((element) => {
                                      if (element.id == 2) {
                                        return true;
                                      }
                                      return false;
                                    })}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        "Rejected",
                                        "Rejected"
                                      )
                                    }
                                  />
                                  <label
                                    className={`form-check-label filterChipText  ms-3  ${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusPink}`}
                                    htmlFor={"Rejected"}
                                  >
                                    Rejected
                                  </label>
                                </li>
                              </ul>
                            </div>
                            <div className="borderWidth row">
                              <ul className="List-Button">
                                <li className="ListBtnItems">
                                  <Link
                                    to={"javascript:void(0)"}
                                    onClick={() => handleClear("status")}
                                    className="secondaryButton "
                                  >
                                    Clear
                                  </Link>
                                </li>
                                <li className="ListBtnItems">
                                  <Link
                                    disabled={
                                      statusOn.length === 0 ? true : false
                                    }
                                    onClick={() => handleApplyFilter("status")}
                                    className="primaryButton"
                                  >
                                    Apply Filter
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        
                        </>
                      )}
                    </div>
                  </div>
                </th>{" "}
                <th id="th" className={ListInfo.tableThPadding}>
                  <span className="textHead_th">Action</span>
                </th>
              </tr>
            </thead>

            <tbody>
              {currentData?.length === 0 ? (
                <tr>
                  <td colspan="15" style={{ textAlign: "center" }}>
                    No records to display
                  </td>
                </tr>
              ) : (
                currentData?.map((kl, ind) => (
                  <tr key={ind}>
                    <td id="td">{kl.serialNumber}</td>
                    <td id="td">
                      <span
                        title={kl.book_title}
                        className={ListInfo.ellipsisText}
                      >
                        {kl.book_title ? kl.book_title : "_"}
                      </span>
                    </td>
                    <td id="td">{kl.username ? kl.username : "_"}</td>
                    <td id="td">{kl.email ? kl.email : "_"}</td>
                    <td id="td">{kl.phone_no ? kl.phone_no : "_"}</td>

                    <td id="td">
                      {[...Array(5)].map((_, index) => (
                        <img
                          key={index}
                          className="ms-1"
                          src={index < kl.rating ? StarIcon : GreyStarIcon} // Fill stars based on rating
                          alt={
                            index < kl.rating
                              ? "Rating Icon"
                              : "Grey Rating Icon"
                          }
                        />
                      ))}
                    </td>
                    <td id="td">
                      <span title={kl.review} className={ListInfo.ellipsisText}>
                        {kl.review ? kl.review : "_"}
                      </span>
                    </td>
                    <td id="td">
                      {kl.date ? moment(kl.date).format("DD/MM/YYYY") : "_"}
                    </td>
                    <td id="td">
                      {kl.status == 0 && (
                        <span
                          className={`${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusYellow}`}
                        >
                          Waiting For Approval{" "}
                        </span>
                      )}
                      {kl.status == 1 && (
                        <span
                          className={`${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusGreen}`}
                        >
                          Approved
                        </span>
                      )}
                      {kl.status == 2 && (
                        <span
                          className={`${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusPink}`}
                        >
                          Rejected
                        </span>
                      )}
                    </td>
                    <td id="td">
                      <img
                        src={ViewIcon}
                        className={ListInfo.cursor_pointer}
                        onClick={() => handleNavigate(kl.id)}
                        alt="view icon"
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="row mt-2">
        <Pagination
          rowsPerPage={rowsPerPage}
          handlePageCount={handlePageCount}
          startPage={
            updateListData && updateListData?.length > 0
              ? currentPage * rowsPerPage + 1 - rowsPerPage
              : 0
          }
          endPage={
            updateListData && updateListData?.length > 0
              ? updateListData?.length < currentPage * rowsPerPage
                ? updateListData?.length
                : currentPage * rowsPerPage
              : 0
          }
          totalRecords={
            updateListData && updateListData?.length > 0
              ? updateListData?.length
              : 0
          }
          handlePrev={(e) => handlePrev(currentPage - 1)}
          currentPrevPage={currentPage === 1}
          prevButton={`${ListInfo.prev_buttonViewAllbook} ${ListInfo.materialIconsRightAndLeft} me-2`}
          handleNext={() => handleNext(currentPage + 1)}
          currentNextPage={currentPage === totalPages || totalPages == 0}
        />
      </div>
    </div>
  );
}
